namespace Gamification.Gamification {
    export interface ProdottiEsperienzePunteggiForm {
        IdProdottoEsperienza: Serenity.IntegerEditor;
        IdentifierPunteggio: Serenity.StringEditor;
        Nome: Serenity.StringEditor;
        Descrizione: Serenity.TextAreaEditor;
        ValoreIniziale: Serenity.IntegerEditor;
        ValoreNegativo: Serenity.BooleanEditor;
    }

    export class ProdottiEsperienzePunteggiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ProdottiEsperienzePunteggi';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProdottiEsperienzePunteggiForm.init)  {
                ProdottiEsperienzePunteggiForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.TextAreaEditor;
                var w3 = s.BooleanEditor;

                Q.initFormType(ProdottiEsperienzePunteggiForm, [
                    'IdProdottoEsperienza', w0,
                    'IdentifierPunteggio', w1,
                    'Nome', w1,
                    'Descrizione', w2,
                    'ValoreIniziale', w0,
                    'ValoreNegativo', w3
                ]);
            }
        }
    }
}
